<template>
  <div class="box">
    <Header title="用户详情"></Header>
    <div class="show-box">
      <div class="title-card"></div>
      <div class="header-info-box">
        <div class="header-line1">
          <div class="header-customer" v-text="this.customer"></div>
          <div class="header-cshname" v-text="this.cshName"></div>
        </div>
        <div class="header-line2">
          <div class="header-line2-left">
            <img
              class="user-img"
              src="../assets/images/userCenterDetail-user2.png"
              alt
            />
          </div>
          <div>
            <div class="header-tag-info">
              <van-icon name="info" @click="iconInfo()" />
              <van-dialog
                width="220"
                v-model="iconInfoDialogShow"
                :show-confirm-button="false"
              >
                <div class="tag-info-close" @click="iconInfoClose()">
                  <van-icon name="cross" />
                </div>
                <div class="tag-info">
                  <img
                    class="tag-info-img"
                    src="../assets/images/systemTag.png"
                  />
                  <div class="tag-info-name1">：系统默认标签</div>
                </div>
                <div class="tag-info" style="padding-bottom: 15px">
                  <img
                    class="tag-info-img"
                    src="../assets/images/userTag.png"
                  />
                  <div class="tag-info-name2">：用户添加标签</div>
                </div>
              </van-dialog>
            </div>
            <div class="header-line2-tag">
              <img class="tag-img" src="../assets/images/systemTag.png" alt />
              <div class="tag-right-box">
                <div
                  class="tag-right"
                  v-for="item in systemTagList"
                  :key="item.index"
                >
                  <div class="tag-itemSystem">{{ item.tagName }}</div>
                </div>
              </div>
              <div v-if="this.systemTagList.length === 0" class="systemNoTag">
                暂无
              </div>
            </div>

            <div class="header-line2-tag">
              <img class="tag-img" src="../assets/images/userTag.png" alt />
              <div id="showTag" class="tag-right-box">
                <div
                  class="tag-right"
                  v-for="item in userTagList"
                  :key="item.index"
                >
                  <div
                    v-if="item.tagName"
                    class="tag-itemUserSet"
                    @click="iconDel(item)"
                  >
                    {{ item.tagName }}
                  </div>
                  <van-icon class="userSet-icon icon-del" name="clear" />
                </div>
              </div>
              <div v-if="this.userTagList.length === 0" class="userSetNoTag">
                暂无
              </div>
            </div>

            <div class="header-line2-tag" style="padding-top: 10px">
              <div style="min-width: 35px"></div>
              <div class="tag-right-box">
                <div
                  class="tag-right"
                  v-for="item in toSelecetTagList"
                  :key="item.index"
                >
                  <div class="tag-itemDefault" @click="iconAdd(item)">
                    {{ item.value }}
                    <van-icon
                      v-if="item.isUsed === 0"
                      class="default-icon"
                      name="add-o"
                    />
                    <van-icon
                      v-if="item.isUsed !== 0"
                      class="default-icon"
                      name="checked"
                    />
                  </div>
                </div>
                <div class="tag-customize" @click="addTagDialog()">
                  自定义
                  <van-icon class="default-icon" name="add-o" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header-line3">
          <img
            class="header-addressIcon"
            src="../assets/images/userCenterDetail-addressIcon.png"
            alt
          />
          <div
            class="header-address"
            v-if="
              this.userProvince &&
              this.userArea &&
              this.userArea &&
              this.purchaserAddress
            "
            v-text="
              this.userProvince +
              this.userCity +
              this.userArea +
              this.purchaserAddress
            "
          ></div>
          <div v-else class="header-address">暂无地址</div>
        </div>
      </div>

      <div class="echart-box">
        <div class="user-chart" ref="userChart1"></div>
      </div>

      <div class="info-detail-box" style="margin-top: 20px">
        <div class="detail-title">
          <div>访问记录</div>
          <div>(最近14天)</div>
        </div>
        <div class="detail-icon">
          <img
            class="icon-img"
            src="../assets/images/userVisitHistory.png"
            alt
          />
        </div>
        <van-list class="list-ul" v-show="this.userViewProductList">
          <li
            class="list-li"
            v-for="(item, index) in userViewProductList"
            :key="index"
            @click="clickToPageDetail(item.productId)"
          >
            <div class="list-index" v-text="index + 1"></div>
            <div
              v-if="item.productId"
              class="list-partNo"
              v-text="item.productId"
            ></div>
            <div v-else class="list-partNo">-</div>
            <div v-if="item.productName" class="list-name" v-text="item.productName"></div>
            <div v-else class="list-name">-</div>
            <div
              v-if="item.count"
              class="list-count"
              v-text="item.count + '次'"
            ></div>
            <div v-else class="list-count">-</div>
          </li>
        </van-list>
        <div v-show="this.userViewProductList == false" class="list-ul">
          暂无访问记录
        </div>
      </div>
    </div>
    <van-dialog
      v-model="dialogShow"
      title="自定义标签"
      show-cancel-button
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <van-field
        v-model="userDefinedName"
        maxlength="10"
        placeholder="请输入自定义标签"
      />
    </van-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import echarts from "echarts";
import {
  getUserBaseData,
  getUserTopView,
  updataTag,
} from "@/api/userCenterDetail";
import { STATUS_CODE_OK } from "@/config";
import { mapActions } from "vuex";
import Header from "@/components/Header";
export default {
  name: "userCenterDetai",
  data() {
    return {
      //头部数据
      customer: "", // 客户名称
      cshName: "", // CSH 简称
      systemTagList: [], //系统默认标签LIST
      userTagList: [], //用户添加标签LIST
      toSelecetTagList: [], //快捷选择标签LIST
      userDefinedName: "", // 用户自定义标签名
      userProvince: "", //地址直辖市
      userCity: "", //地址市
      userArea: "", //地址区
      purchaserAddress: "", //地址详细地址
      //E-chart图表
      monthXdata: [], // X轴
      monthLeftYdata: [], //客户增加数量 左Y轴
      monthRightYdata: [], //下单客户数量 右Y轴
      userViewProductList: [], //访问记录LIST
      taginfoWidth: 0, //标签信息按钮宽度
      echartsWidth: 0, //获取图表宽度
      dialogShow: false, //自定义标签弹框显示FLG
      iconInfoDialogShow: false, //标签信息说明弹框显示FLG
      systemTagFlg: false, //系统默认标签有无FLG
    };
  },
  mounted() {
    //初期获取标签信息按钮宽度
    this.taginfoWidth = $(document.body).width() - 160;
    this.taginfoWidth = this.taginfoWidth + "px";
    $(".header-tag-info").css("width", this.taginfoWidth);
    //初期获取图表宽度
    this.echartsWidth = $(document.body).width() - 30;
    this.echartsWidth = this.echartsWidth + "px";
    $(".user-chart").css("width", this.echartsWidth);
    //初期获取画面展示数据
    this.getInfo();
    //获取用户浏览记录
    this.getUserViewInfo();
  },
  methods: {
    //获取画面展示数据
    async getInfo() {
      // 订单数量
      this.userChart1 = echarts.init(this.$refs.userChart1);
      this.userChart1.setOption({
        grid: {
          left: "18%",
          right: "15%",
          bottom: "15%",
        },
        legend: {
          data: ["支付金额(元)", "订单数量"],
          inactiveColor: "#999",
          x: "center",
          y: "top",
          itemWidth: 25,
          itemHeight: 10,
          padding: [15, 0, 0, 0],
          textStyle: {
            fontSize: 10,
          },
          itemGap: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
              show: false,
            },
          },
          confine: true,
          extraCssText: "font-size: 12px; text-align: left;",
          position: function (point, params, dom) {
            dom.style.transform = "translateZ(0)";
          },
          formatter: function (params) {
            var dotHtml =
              '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:#eeeeee"></span>';
            return (
              "<支付金额(元) / 订单数量>" +
              "</br>" +
              dotHtml +
              params[0]["data"].name +
              " : " +
              params[0]["data"].value +
              " / " +
              params[1]["data"].value
            );
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.monthXdata,
            axisLine: {
              show: true, //x轴
            },
            axisTick: {
              show: false, //x轴刻度线
            },
            axisLabel: {
              showMaxLabel: true, //显示最大刻度值
              interval: 1,
              rotate: 30,
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "支付金额(元)",
            nameTextStyle: {
              color: "#000",
              fontSize: "12",
              fontFamily: "Helvetica",
              padding: [0, 50, 5, 0],
            },
            position: "left",
            axisLine: {
              show: true, //y轴
            },
            axisTick: {
              show: true, //y轴刻度线
            },
            splitLine: {
              show: false, //y轴网格线
            },
          },
          {
            type: "value",
            name: "订单数量",
            nameTextStyle: {
              color: "#000",
              fontSize: "12",
              fontFamily: "Helvetica",
              padding: [0, 0, 5, 10],
            },
            position: "right",
            axisLine: {
              show: true, //y轴
            },
            axisTick: {
              show: true, //y轴刻度线
            },
            splitLine: {
              show: false, //y轴网格线
            },
          },
        ],
        series: [
          {
            name: "支付金额(元)",
            type: "line",
            data: this.monthLeftYdata,
            // symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            color: "#DEB248",
          },
          {
            name: "订单数量",
            type: "bar",
            yAxisIndex: 1,
            data: this.monthRightYdata,
            barWidth: "50%", //柱图宽度
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              borderWidth: "10",
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#da291c" },
                { offset: 1, color: "#eeeeee" },
                { offset: 1, color: "#dcdcdc" },
              ]),
            },
          },
        ],
      });

      //调用后台获取数据
      let { data } = await getUserBaseData({
        userCode: this.$route.params.userCode, //客户号
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        //Header部数据
        this.customer = data.memberBaseInfoVo.displayName; //客户名称
        this.cshName = data.memberBaseInfoVo.userCshName; //CSH 简称
        if (data.memberBaseInfoVo.userProvince) {
          this.userProvince = data.memberBaseInfoVo.userProvince;
        } //地址直辖市
        if (data.memberBaseInfoVo.userCity) {
          this.userCity = data.memberBaseInfoVo.userCity;
        } //地址市
        if (data.memberBaseInfoVo.userArea) {
          this.userArea = data.memberBaseInfoVo.userArea;
        } //地址区
        if (data.memberBaseInfoVo.purchaserAddress) {
          this.purchaserAddress = data.memberBaseInfoVo.purchaserAddress;
        }
        //地址详细地址
        if (
          data.memberBaseInfoVo.userSystemTagVo.defaultSystemTagVoList.length >
          0
        ) {
          this.systemTagList =
            data.memberBaseInfoVo.userSystemTagVo.defaultSystemTagVoList; //系统默认标签
        }
        if (data.memberBaseInfoVo.userSystemTagVo.userTagVoList.length > 0) {
          this.userTagList =
            data.memberBaseInfoVo.userSystemTagVo.userTagVoList; //用户添加标签
        }
        if (
          data.memberBaseInfoVo.userSystemTagVo.toSelecetTagVoList.length > 0
        ) {
          this.toSelecetTagList =
            data.memberBaseInfoVo.userSystemTagVo.toSelecetTagVoList; //快捷标签
        }
        console.log(this.systemTagList);
        //X轴数据取得
        this.monthXdata = data.memberBaseInfoVo.orderAmmountData.monthScaleData;
        //客户增加数量 左Y轴数据取得
        this.monthLeftYdata = data.memberBaseInfoVo.orderAmmountData.data;
        //下单客户数量 右Y轴数据取得
        this.monthRightYdata = data.memberBaseInfoVo.orderCountData.data;
        // 交易金额E-hart图表填充
        this.userChart1.setOption({
          xAxis: [
            {
              data: this.monthXdata,
            },
          ],
          series: [
            {
              data: this.monthLeftYdata,
            },
            {
              data: this.monthRightYdata,
            },
          ],
        });
      }
    },
    //获取用户浏览记录
    async getUserViewInfo() {
      //调用后台获取数据
      let { data } = await getUserTopView({
        userCode: this.$route.params.userCode, //客户号
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        this.userViewProductList = data.myProductAccessCntVO;
      }
    },
    //点击自定义标签
    addTagDialog() {
      this.dialogShow = true;
      this.userDefinedName = "";
    },
    //点击自定义标签弹框-取消
    onCancel() {
      this.dialogShow = false;
    },
    //点击自定义标签弹框-确认
    onConfirm() {
      var userDefinedNameFlg = "";
      //判定自定义标签输入名称重复时，自定义标签FLG设定
      for (var i = 0; i < this.userTagList.length; i++) {
        if (this.userTagList.length > 0) {
          if (this.userDefinedName === this.userTagList[i].tagName) {
            userDefinedNameFlg = false;
            if (!userDefinedNameFlg) {
              this.$dialog.alert({
                message: "此自定义标签已添加",
              });
            }
            return;
          } else {
            userDefinedNameFlg = true;
          }
        }
      }
      //无用户标签时，自定义标签FLG设定
      if (this.userTagList.length === 0) {
        userDefinedNameFlg = true;
      }
      if (this.userDefinedName && userDefinedNameFlg) {
        this.updataUserTag("", this.userDefinedName, "1");
      }
      this.userDefinedName = "";
      this.dialogShow = false;
    },
    //点击标签信息说明弹框
    iconInfo() {
      this.iconInfoDialogShow = true;
    },
    //点击标签信息说明弹框关闭
    iconInfoClose() {
      this.iconInfoDialogShow = false;
    },
    //点击添加备选标签
    iconAdd(item) {
      if (item.isUsed !== 0) {
        this.$dialog.alert({
          message: "此标签已添加",
        });
      } else {
        this.updataUserTag("", item.value, "1");
      }
    },
    //点击删除标签
    iconDel(item) {
      this.$dialog
        .confirm({
          message: "请确认是否删除标签",
        })
        .then(() => {
          this.updataUserTag(item.tagId, item.tagName, "2");
        })
        .catch(() => {});
    },
    //标签添加-删除
    async updataUserTag(id, name, flg) {
      //调用后台获取数据
      let { data } = await updataTag({
        userCode: this.$route.params.userCode, //客户号
        tagsId: id, //标签ID
        tagsName: name, //标签名称
        updateFlg: flg, //添加-删除操作
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        this.systemTagList = data.defaultSystemTagVoList;
        this.userTagList = data.userTagVoList;
        this.toSelecetTagList = data.toSelecetTagVoList;
      }
    },

    //点击List数据跳转页面
    clickToPageDetail(id) {
      this.setPartNo(id);
      this.$router.push({
        name: "partInquriyDetail",
      });
    },
    ...mapActions(["setPartNo"]),
  },
  components: {
    Header,
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  .header-info-box {
    border-radius: 20px;
    width: 100%;
    padding: 20px 10px 10px 10px;
    .header-line1 {
      display: flex;
      color: #000;
      .header-customer {
        width: 82%;
        font-size: 14px;
        text-align: left;
        font-weight: bold;
      }
      .header-cshname {
        width: 18%;
        font-size: 12px;
        text-align: right;
        padding: 5px 5px 0px 0px;
      }
    }
    .header-tag-info {
      text-align: right;
      font-size: 12px;
    }
    .tag-info-close {
      position: relative;
      right: 10px;
      top: 10px;
      font-size: 18px;
    }
    .tag-info {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      padding: 0px 15px 0px 0px;
      .tag-info-img {
        width: 35px;
      }
      .tag-info-name1 {
        color: #6b6b6d;
      }
      .tag-info-name2 {
        color: #e78177;
      }
    }

    .header-line2 {
      padding-top: 10px;
      display: flex;
      .header-line2-left {
        .user-img {
          padding-top: 20px;
          width: 120px;
        }
      }
      .header-line2-tag {
        display: flex;
        .tag-img {
          width: 35px;
          height: 35px;
        }
        .tag-right-box {
          padding: 5px 0px 0px 0px;
          margin: 0px 0px 0px 5px;
          .tag-right {
            margin: 0px 0px 5px 0px;
            display: flex;
            float: left;
            box-sizing: border-box;
            font-size: 12px;
            color: #ffffff;
            .tag-itemSystem {
              height: 25px;
              border: 1px solid #6b6b6d;
              background-color: #6b6b6d;
              border-radius: 10px;
              padding: 3px 5px;
              margin: 0px 5px 0px 0px;
            }
            .tag-itemUserSet {
              min-width: 50px;
              height: 25px;
              line-height: 18px;
              border: 1px solid #e78177;
              background-color: #e78177;
              border-radius: 10px;
              padding: 3px 5px;
            }
            .tag-itemDefault {
              height: 25px;
              border: 1px solid #999;
              border-radius: 10px;
              color: #999;
              padding: 3px 5px;
              margin: 0px 5px 0px 0px;
            }
            .userSet-icon {
              position: relative;
              top: 0px;
              right: 5px;
              font-size: 10px;
            }
            .default-icon {
              top: 1px;
              right: 0px;
              font-size: 10px;
            }
            .icon-del {
              color: red;
            }
            /deep/ .van-icon-clear::before {
              border: 2px solid #ffffff;
              border-radius: 10px;
            }
          }
          .tag-customize {
            float: left;
            border: 1px solid #999;
            border-radius: 10px;
            font-size: 12px;
            padding: 3px 5px;
            .default-icon {
              top: 1px;
              right: 0px;
              font-size: 10px;
            }
          }
        }
        .systemNoTag {
          margin: 5px 0px 0px 0px;
          min-width: 50px;
          height: 25px;
          line-height: 18px;
          border: 1px solid #6b6b6d;
          background-color: #6b6b6d;
          border-radius: 10px;
          padding: 3px 5px;
          font-size: 12px;
          color: #ffffff;
        }
        .userSetNoTag {
          margin: 5px 0px 0px 0px;
          min-width: 50px;
          height: 25px;
          line-height: 18px;
          border: 1px solid #e78177;
          background-color: #e78177;
          border-radius: 10px;
          padding: 3px 5px;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
    .header-line3 {
      display: flex;
      padding-top: 10px;
      .header-addressIcon {
        object-fit: cover;
        margin-left: 20px;
        width: 20px;
        height: 20px;
      }
      .header-address {
        text-align: left;
        font-size: 12px;
        color: #000;
        padding: 2px 10px 0px 5px;
      }
    }
  }

  .echart-box {
    margin: 20px 0px 0px 0px;
    width: 100%;
    height: 300px;
    border-radius: 20px;
    .user-lastOrderdate {
      display: flex;
      position: relative;
      justify-content: flex-end;
      font-size: 12px;
      right: 15px;
      top: 25px;
      .lastOrderdate-title {
        font-size: 10px;
        padding-right: 10px;
      }
      .lastOrderdate-content {
        color: #000;
      }
    }
    .user-chart {
      padding: 5px;
      height: 300px;
    }
    /deep/ .van-swipe__indicators {
      bottom: 25px;
    }
  }

  .info-detail-box {
    width: 100%;
    border-radius: 20px;
    padding: 20px;
    .detail-title {
      width: 40%;
      text-align: left;
      font-size: 14px;
      font-weight: bold;
      color: #000000;
      padding-bottom: 5px;
      border-bottom: 1px solid #dcdcdc;
    }
    .detail-icon {
      position: absolute;
      left: 100px;
      top: 15px;
      .icon-img {
        width: 50px;
      }
    }
  }
  .list-ul {
    border-radius: 0px 0px 20px 20px;
    font-size: 12px;
    margin: 20px 0px;
    .list-li {
      display: flex;
      height: 50px;
      align-items: center;
      text-align: left;
      .list-index {
        width: 8%;
        padding-right: 5px;
      }
      .list-partNo {
        width: 35%;
        padding-right: 8px;
        color: #c29f25;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
      }
      .list-name {
        width: 42%;
        padding-right: 5px;
        color: #000;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
      }
      .list-count {
        text-align: right;
        width: 15%;
        font-size: 10px;
      }
    }
  }

  /deep/ .van-field__control {
    text-align: center;
  }
  /deep/ .van-cell--clickable {
    justify-content: flex-end;
    padding: 0px;
    background: unset;
  }
  /deep/ .van-collapse-item__content {
    padding: 0px;
    // background: unset;
    background-color: #ffffff;
    // height: 100px;
  }
}
</style>